import React from 'react';

import {useCurrentUserState} from 'app/current-user/api';
import {useSlimTasks} from 'app/tasks/api';
import {VeryCompactTaskItem} from 'app/tasks/components/TasksDashboard/VeryCompactTaskItem';
import {getStartEndIntervalFromParams} from 'app/tasks/interval-filter';
import {gt} from 'app/utils/i18n';

import {DashboardListWidget} from './DashboardListWidget';

export function RecentTasksWidget() {
  const {timezone: userTimezone} = useCurrentUserState().data!;

  return (
    <DashboardListWidget
      icon="fa fa-tasks"
      title={gt('Tasks Due This Week')}
      hook={useSlimTasks}
      params={{
        page_size: 5,
        ...getStartEndIntervalFromParams({interval: 'this-week'}, userTimezone),
      }}
      emptyMessage={gt('No Tasks Due')}
      renderItem={(task) => <VeryCompactTaskItem task={task} />}
    />
  );
}
